import { Controller } from '@hotwired/stimulus'

// Copies text to clipboard and briefly confirms on the button.
export default class extends Controller {
  static targets = ['label']
  static values = {
    text: String,
    successLabel: { type: String, default: 'Copied!' }
  }

  async copy (event) {
    event.preventDefault()
    const value = this.textValue
    if (!value) return

    const button = event.currentTarget
    const label = this.hasLabelTarget ? this.labelTarget : button
    const original = label.textContent

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value)
      } else {
        this.legacyCopy(value)
      }
      label.textContent = this.successLabelValue
      window.setTimeout(() => { label.textContent = original }, 1600)
    } catch (_) {
      label.textContent = 'Press Ctrl+C'
      window.setTimeout(() => { label.textContent = original }, 2000)
    }
  }

  legacyCopy (value) {
    const input = document.createElement('textarea')
    input.value = value
    input.setAttribute('readonly', '')
    input.style.position = 'absolute'
    input.style.left = '-9999px'
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
  }
}
